<template>
  <div id="filtroPlanificacionAnualCharter">
    <Button
      :size="15"
      color="#fd7e14"
      colorText="#ffffff"
      title="Filtrar contenido"
      icon="fas fa-filter"
      :width="30"
      round
      traslate
      class="m-1"
      @click.native="openModal('modal')"
    />

    <ui-modal ref="modal" :title="`Filtrar contenido de planificaciones anuales`" size="normal">

      <div class="m-1 mb-3">
        <!-- Años -->
        <ui-select
          class="w-100 mr-3"
          has-search
          label="Año"
          placeholder="Seleccionar"
          searchPlaceholder="Buscar"
          :keys="{ label: 'year', value: 'id' }"
          :options="listaAnios"
          v-model="anioModel"
          @change="habilitarBtn"
        ></ui-select>

        <!-- Empresas -->
        <ui-select
          class="w-100 mr-3"
          has-search
          label="Empresas"
          placeholder="Seleccionar"
          searchPlaceholder="Buscar"
          :keys="{ label: 'name', value: 'id' }"
          :options="listaClientesUsuarioActual"
          v-model="clientesModel"
          @change="habilitarBtn"
          v-if="showSelectClientes"
        ></ui-select>

        <!-- Pallet -->
        <ui-select
          class="w-100 mr-3"
          has-search
          label="Pallet"
          placeholder="Seleccionar"
          searchPlaceholder="Buscar"
          :keys="{ label: 'name', value: 'id' }"
          :options="listaPallet"
          v-model="palletsModel"
          @change="habilitarBtn"
        ></ui-select>

        <!-- Regiones -->
        <ui-select
          class="w-100 mr-3"
          has-search
          label="Región"
          placeholder="Seleccionar"
          searchPlaceholder="Buscar"
          :keys="{ label: 'name', value: 'id' }"
          :options="listaRegiones"
          v-model="regionModel"
          @change="habilitarBtn"
        ></ui-select>

        <!-- Servicio integral -->
        <ui-select
          class="w-100 mr-3 mb-3"
          has-search
          label="Servicio integral"
          placeholder="Seleccionar"
          searchPlaceholder="Buscar"
          :keys="{ label: 'name', value: 'id' }"
          :options="optionsServicioIntegral"
          v-model="servicioIntegralModel"
          @change="habilitarBtn"
        ></ui-select>
      </div>

      <!-- Footer -->
      <div class="d-flex justify-content-between my-3">
        <button class="btn btn-secondary" @click="clear">Limpiar</button>
        <button class="btn btn-secondary" @click="quitarFiltro">Quitar Filtro</button>
        <button class="btn btn-danger" v-bind:class="{ disabled: !desactivarBtnFiltrar }" @click="filtrarLista">Filtrar</button>
      </div>
    </ui-modal>
  </div>
</template>

<script>
// Select UI
import UiModal from "keen-ui/src/UiModal";
import UiSelect from "keen-ui/src/UiSelect";

// Componentes
import Button from "../../common/Button";

// Variables globales STORE
import { mapActions, mapState } from "vuex";
import { filterPlanificacionAnualCharter } from '../../../constants/charter';

export default {
  data() {
    return {
      anioModel: {},
      clientesModel: {},
      palletsModel: {},
      optionsServicioIntegral: [
        { id: 0, name: "Sin servicio integral" },
        { id: 1, name: "Con servicio integral" },
      ],
      regionModel : {},
      servicioIntegralModel: {},
      desactivarBtnFiltrar: false,
      showSelectClientes : false
    };
  },

  computed: {
    ...mapState(["listaClientesUsuarioActual","usuarioActual"]),
    ...mapState("charter", ["dataDataTablePlanificacionAnualFiltrada","listaAnios","listaPallet","listaRegiones"]),
  },

  components: { UiModal, UiSelect, Button },

  methods: {
    ...mapActions("charter", [
      "actionSetFilterDataDataTablePlanificacionAnual",
      "actionSetDataPlanificacionAnualTabla"
    ]),

    openModal(ref) {
      this.$refs[ref].open();
    },
    closeModal(ref) {
      this.$refs[ref].close();
    },

    clear() {
      this.anioModel = {};
      this.clientesModel = [];
      this.palletsModel = [];
      this.servicioIntegralModel = [];

      // this.actionSetLimpiarDataDataTablePlanificacionAnual();
      this.desactivarBtnFiltrar = false;

      this.closeModal("modal");
    },

    async filtrarLista() {

      const dataFormat = {
        "year": Object.keys(this.anioModel).length ? this.anioModel.id : null,
        "pallet_id": Object.keys(this.palletsModel).length ? this.palletsModel.id : null,
        "client_id": Object.keys(this.clientesModel).length ? this.clientesModel.id : null,
        "servicio_integral" : Object.keys(this.servicioIntegralModel).length ? this.servicioIntegralModel.id : null,
        "route_id": Object.keys(this.regionModel).length ? this.regionModel.id : null,
      }

      let {code, data } = await filterPlanificacionAnualCharter(dataFormat);

      if (code == 200) {

        this.actionSetFilterDataDataTablePlanificacionAnual(data);

      } 
      
      // this.closeModal("modal");

    },
    // Deshabilita el boton filtar
    habilitarBtn() {
      let me = this;

      Object.keys(me.anioModel).length ||
      Object.keys(me.clientesModel).length ||
      Object.keys(me.palletsModel).length ||
      Object.keys(me.regionModel).length ||
      Object.keys(me.servicioIntegralModel).length
        ? (me.desactivarBtnFiltrar = true)
        : (me.desactivarBtnFiltrar = false);
    },

    async quitarFiltro(){

      const dataFormat = {
        "year": null,
        "pallet_id": null,
        "client_id": null,
        "servicio_integral" : null,
        "route_id": null,
      }

      let {code, data } = await filterPlanificacionAnualCharter(dataFormat);

      if (code == 200) {
        this.actionSetFilterDataDataTablePlanificacionAnual(data);
      } 

    }
  },

  mounted(){

  if (this.usuarioActual.rol == 'Administrador' || this.usuarioActual.rol == "Ejecutivo" || this.usuarioActual.rol == "Super Administrador") {

      this.showSelectClientes = true;

  }else{

      this.showSelectClientes = false;
      this.clientesModel = [{id:this.usuarioActual.id_cliente, name:this.usuarioActual.cliente}];

  }

  },
};
</script>

<style>

  #filtroPlanificacionAnualCharter .ui-modal__container {
    width: 45% !important;
    height: auto !important;
  }

</style>
